import { createCommonApiResponseSchema } from "@/server/agentTypes";
import { z } from "zod";

export const GetApplicationAgreeResponseSchema = createCommonApiResponseSchema(
  z.object({
    isAgree: z.boolean().optional(),
  })
);
